const isWebApp = () => {
    const isAndroidApp = navigator.userAgent.search("pmkino-webapp-android")
    const isiOSApp = navigator.userAgent.search("iOS WebApp")
  
    if(isAndroidApp !== -1 || isiOSApp !== -1) {
      return true
    } else {
      return false
    }
  };
  
  export default isWebApp;